import { render, staticRenderFns } from "./scene-investment.vue?vue&type=template&id=7d7d58a4&"
import script from "./scene-investment.vue?vue&type=script&lang=js&"
export * from "./scene-investment.vue?vue&type=script&lang=js&"
import style0 from "./scene-investment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports